import { IPropertyAddressResponse } from './IPropertyAddressResponse';

export type IPropertyAddressData = IPropertyAddressResponse;


export const propertyAddressToString = ({
  streetAddress,
  unit,
  city,
  stateAbbreviation,
  zipCode,
}: Pick<IPropertyAddressData, 'streetAddress' | 'city' | 'stateAbbreviation' | 'unit' | 'zipCode'>) =>
  `${streetAddress}${unit ? ` ${unit}` : ''} ${city}, ${stateAbbreviation} ${zipCode}`;
